import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.187.816c.521.25 1.136.612 1.625 1.1.489.49.851 1.105 1.1 1.626.313.653.11 1.407-.402 1.919l-7.213 7.214c-.31.31-.689.54-1.106.674L5.97 14.702a.75.75 0 0 1-.943-.943L6.38 9.537a2.75 2.75 0 0 1 .674-1.105l7.214-7.214c.512-.511 1.266-.714 1.919-.402zm.21 2.515a3.608 3.608 0 0 0-.827-.586L8.575 9.739a1.002 1.002 0 0 0-.178.242L6.9 12.828l2.847-1.497c.09-.047.17-.107.242-.178l6.994-6.994a3.61 3.61 0 0 0-.586-.828zM2 4.225a.5.5 0 0 1 .471-.499l5.53.004a1 1 0 0 0 0-2L2.5 1.726a2.5 2.5 0 0 0-2.5 2.5v12.577c0 .76.083 1.184.32 1.627.223.418.558.753.977.977.442.237.866.319 1.627.319h12.154c.76 0 1.185-.082 1.627-.319.419-.224.753-.559.977-.977.237-.443.319-.867.319-1.627v-5.078a1 1 0 1 0-2 0v5.078c0 .458-.022.57-.082.683a.364.364 0 0 1-.157.157c-.113.06-.226.082-.684.082H2.924c-.459 0-.571-.021-.684-.082a.363.363 0 0 1-.157-.157c-.06-.113-.082-.225-.082-.683L2 4.225z",
      fill: "#fff"
    })
  }));
};
export default SvgComponent;